import styles from '../UnifyOnboarding.module.scss';

export const ConnectionStatus = ({
	source,
	provider,
	kind = 'stock',
	onEdit
}) => {
	const isStock = kind === 'stock';
	const title = isStock ? 'Stock inventory connection' : 'Product data connection';

	if (!source?.pointOfSale && !isStock) {
		return (
			<div className={styles.completedInfo}>
				<div>
					<p>
						<strong>{title} (optional)</strong>
					</p>
					<p className={styles.helperText}>
						Not connected. Connecting a source lets us import your product titles, images, and descriptions for you.
					</p>
					<button className={styles.linkButton} onClick={onEdit}>
						Connect product data
					</button>
				</div>
			</div>
		);
	}

	if (!source?.pointOfSale) {
		return null;
	}

	const providerLabel = source.providerLabel || provider?.label;

	return (
		<div className={`${styles.completedInfo} ${isStock ? styles.stockConnectionBox : ''}`}>
			<div>
				<p>
					<strong>{title}</strong>
				</p>
				<p className={styles.helperText}>
					Connected via {providerLabel}
				</p>
				{source.latestIngest?.timestamp ? (
					<p className={styles.helperText}>
						Last synced: {new Date(source.latestIngest.timestamp).toLocaleString()}
					</p>
				) : (
					<p className={styles.helperText}>
						Awaiting first sync
					</p>
				)}
				<button className={styles.linkButton} onClick={onEdit}>
					Update connection
				</button>
			</div>
		</div>
	);
};
